// src/hooks/useInvites.js
import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { fetchInvites, resendInvite, sendInvite } from "PlatForms/OrgLMS/Services/AdminServices/InviteUsersService";

export const useInvites = (selectedRole) => {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [resendingId, setResendingId] = useState(null); 


  const getInvites = async () => {
    try {
      setLoading(true);
      const data = await fetchInvites(selectedRole);
      setInvites(data);
    } catch (err) {
      setError(err);
      message.error("Failed to fetch invites");
    } finally {
      setLoading(false);
    }
  };

const handleResend = async (inviteId) => {
  setResendingId(inviteId);
  
  Modal.confirm({
    title: "Are you sure you want to resend the invitation?",
    content: "This will resend the invitation to the user.",
    okText: "Resend",
    cancelText: "Cancel",
    onOk: async () => {
      try {
        // Optimistically update the timestamp before API call
        setInvites(prev => prev.map(invite => 
          invite.id === inviteId 
            ? { ...invite, inviteSentAt: new Date().toISOString() } 
            : invite
        ));

        const result = await resendInvite(inviteId);
        
        // Final update with server response
        setInvites(prev => prev.map(invite => 
          invite.id === inviteId 
            ? { ...invite, ...result.data } 
            : invite
        ));
        
        message.success("Invitation resent successfully!");
      } catch (error) {
        // Revert if API call fails
        setInvites(prev => prev.map(invite => 
          invite.id === inviteId 
            ? { ...invite, inviteSentAt: error.originalInviteSentAt } 
            : invite
        ));
        
        console.error("Resend error:", error);
        message.error(error.response?.data?.message || "Failed to resend invitation");
      } finally {
        setResendingId(null);
      }
    }
  });
};


const handleSendInvite = async (inviteData) => {
  try {
    const response = await sendInvite(inviteData);
    await getInvites();
    return { success: true, data: response };
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 400) {
        return { success: false, error: data };
      }
    }
    return { success: false, error: { message: error.message } }; 
  }
};

  useEffect(() => {
    getInvites();
  }, []);

  return {
    invites,
    loading,
    error,
    getInvites,
    handleResend,
    handleSendInvite,
    resendingId, 

  };
};
